import React from "react";
import "./Events.css";
import pic from "../../assets/Group 23.png";
const Events = () => (
  <div className='events__container section__padding' id='events'>
    <img src={pic} />
  </div>
);

export default Events;
